import styled from 'styled-components'

export const ItemStyle = styled.div`
  color: ${({ theme }) => theme?.colors?.textColor};
  display: flex;
  flex-direction: column;
  gap: 5px;
  justify-content: center;
  font-family: 'Manrope', sans-serif;
`
export const HotelCartTitle = styled.p`
  font-size: 12px;
  font-weight: 600;
  position: relative;
  line-height: 16.5px;
  margin: 0;

  span {
    font-weight: 800;
  }
`

export const ContentItemlStyle = styled.div`
  align-items: top;
  justify-content: space-between;
  display: flex;
  position: relative;
`

export const DescStyle = styled.div`
  * {
    margin: 0;
  }

  p {
    font-size: 12px;
    text-align: left;
  }

  small {
    color: ${({ theme }) => theme?.colors?.gray6};
    font-size: 10px;
    text-align: left;
  }
`

export const ValStyle = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 5px;

  & div {
    align-items: baseline;
    display: flex;
    flex-flow: row nowrap;
  }

  span#nights {
    color: ${({ theme }) => theme?.colors?.gray6};
    font-size: 10px;
    font-weight: normal;
  }
`

export const CartFooter = styled.div`
  align-items: center;
  display: flex;
`
export const Badges = styled.div`
  align-items: center;
  display: flex;
  flex-flow: row wrap;
  gap: 5px;
  margin-top: 5px;
`

export const StyleQuantity = styled.div`
  align-items: center;
  display: flex;
  max-width: 93px;
  justify-content: space-between;
`

export const PersonStyle = styled.div`
  align-items: center;
  display: flex;
  gap: 5px;
`

export const ChangeQuantityRoomsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  width: 100%;

  .quantity-rooms {
    font-size: 13px;
    font-weight: 600;
    width: 136px;
    padding-top: 0;
    padding-top: 0;
  }

  & .MuiInputBase-root {
    width: 65px;
    height: 32px;
    min-height 32px;
    margin: 0;
  }
`
